import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { Button, TextLink } from '@vds/buttons';
import { Fragment } from "react";
import { modalContent as Content } from "../cms/modalContent";

function AppleModal(props) {
  const prodId  = props.prodId
  const content = Content?.info?.find(item => item.prodId === props.prodId);

  const close = ()=>{
    props.onClose();
  }

  const onBtnClick = (newProductId, existingProdId) =>{
    props.onBtnClick(newProductId, existingProdId);
  }

  const onLinkClick = (newProductId, existingProdId) =>{
    props.onLinkClick(newProductId, existingProdId);
  }

    return (<>
    <Modal opened={true} disableOutsideClick={true} surface="light" fullScreenDialog={false} disableAnimation={false} ariaLabel="Apple conflict modal">
    <ModalTitle>
      {content?.title}
    </ModalTitle>
    <ModalBody>
      {content?.text?.map(msg => (<Fragment><div style={{margin: "16px 0 10px"}}>{msg}</div></Fragment>))}  
    </ModalBody>
    <ModalFooter children={
      <>
        {
          content?.actions?.map(item => (
          <Fragment>
                <div className="flexColumn">
                  { item.type === "button" &&  <Button className={item.id === 'R3557' && item.label == 'Got it' ? 'defaultModalBtn' : ''} size={item.size} primary={item.primary} secondary={item.secondary} id={item.id} width={item.width} onClick={() => onBtnClick(item.id, props.prodId)}>{item.label}</Button> }
                  { item.type === 'textlink' && <TextLink type="standAlone" surface="light"  disabled={item.disabled} onClick={e => onLinkClick(item.id, props.prodId)}> {item.label} </TextLink>}
                </div>
          </Fragment>)
          )
        }
      </>
    } />
    </Modal>
    </>)
}

export default AppleModal;
